/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreGroup } from '../../models/store-group';
import { StoreGroupInput } from '../../models/store-group-input';

export interface CreateStoreGroup$Params {
  'Active-Tenant-Identifier': string;
      body: StoreGroupInput
}

export function createStoreGroup(http: HttpClient, rootUrl: string, params: CreateStoreGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreGroup>> {
  const rb = new RequestBuilder(rootUrl, createStoreGroup.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreGroup>;
    })
  );
}

createStoreGroup.PATH = '/store-groups';
